import Layout from '@layouts/Layout';
import TermsOfUse from '@screens/Legal/TermsOfUse';

import React, { memo } from 'react';

const title = 'Terms of use';
const description = 'You can find Traqq’s terms of service here. By using Traqq’s products, you automatically agree to our terms of service. Read them on this page.';

const TermsPage = () => (
    <Layout
        title={ title }
        description={ description }
    >
        <TermsOfUse />
    </Layout>
);

export default memo(TermsPage);
